export default __webpack_public_path__ + "static/media/research.7dffd183.svg";